/* Ale Dublin - rewrites Dawn's Sale badge to Save X% on product cards.
   Loaded on every template from layout/theme.liquid.
   Safe to run more than once: the ale-card-save class guards re-entry. */
(function () {
  function money(t) {
    if (!t) return null;
    var s = t.replace(/[^0-9.,]/g, '');
    if (!s) return null;
    var d = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    if (d > -1) {
      return parseFloat(s.slice(0, d).replace(/[.,]/g, '') + '.' + s.slice(d + 1).replace(/[.,]/g, ''));
    }
    return parseFloat(s);
  }

  function run() {
    document.querySelectorAll('.card-wrapper, .card').forEach(function (card) {
      var p = card.querySelector('.price--on-sale');
      if (!p) return;
      var reg = p.querySelector('.price__sale .price-item--regular') || p.querySelector('.price-item--regular');
      var sale = p.querySelector('.price-item--sale');
      if (!reg || !sale) return;
      var r = money(reg.textContent), s = money(sale.textContent);
      if (!r || !s || r <= s) return;
      var pct = Math.round((r - s) / r * 100);
      var b = card.querySelector('.badge');
      if (b && !b.classList.contains('ale-card-save')) {
        b.textContent = 'Save ' + pct + '%';
        b.classList.add('ale-card-save');
      }
    });
  }

  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('load', run);
})();
